module.exports = __webpack_public_path__ + "static/media/recruitment.9a057860.png";